export default __webpack_public_path__ + "static/media/edit-icon.5a0bd978.svg";